<template>
  <div class="dropdown-search-container">
    <div class="search-module">
      <input class="search-text"
        @blur="handleBlur"
        @focus="handleFocus"
        @input="debounceHandleChange($event)"
        @compositionstart="handleCompositionstart"
        @compositionend="handleCompositionend"
        :placeholder="placeholder"
        v-model="currentValue"
        ref="input"
      />
      <ul class="list-module" v-show="itemList.length && showList" ref="list">
        <li v-for="(item, index) in itemList" @click="handleItemClick(item)" :key="index">
          <span class="list-item-text" v-html="heightLight(item, currentValue)"></span>
        </li>
      </ul>
      <div class="info-prompt" v-if="requiredPrompt && showPrompt">
        <div class="icon"></div>
        {{promptText}}
      </div>
    </div>
  </div>
</template>

<script>
import Tools from '@utils';
export default _extend({
  name: 'DropDownSearch',
  props: {
    field: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    itemList: {
      type: Array,
      default: []
    },
    inputValue: {
      type: String,
      default: ''
    },
    requiredPrompt: {
      type: Boolean,
      default: false
    },
    promptText: {
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      flag: true,
      showList: true,
      currentValue: this.inputValue,
      dataList: [],
      showPrompt: false,
      // 加个标识判断值是否为选择填充的
      isSelect: false
    };
  },
  watch: {
    showPrompt(val) {
      this.$emit('updateError', this.field, val);
    },
    itemList() {
      this.$refs.list.scrollTop = 0;
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    heightLight(str, key) {
      try {
        const reg = new RegExp(key, 'g');
        return str.replace(reg, (val) => {
          return `<span style="color: #4981F2; vertical-align: unset;">${val}</span>`;
        });
      } catch (error) {
        return str;
      }
    },
    handleChange(event) {
      const value = event.target.value;
      this.currentValue = value;
      const trimValue = value ? value.trim() : value;
      setTimeout(() => {
        if (this.flag) {
          this.showList = true;
          this.$emit('dropDownChange', trimValue);
        }
        if (!trimValue) {
          this.showList = false;
        }
      }, 0);
      // 手动填的都是错的
      this.isSelect = false;
      this.showPrompt = true;
    },
    handleItemClick(value) {
      this.currentValue = value;
      this.showList = false;
      // 填写后必须是点击才算填写正确
      this.isSelect = true;
      this.showPrompt = false;
      // 需要执行showPrompt的watch，所以设置一下setimeout
      setTimeout(() => {
        this.$emit('selectedData', value);
      }, 0);
    },
    handleCompositionstart() {
      this.flag = false;
    },
    handleCompositionend() {
      this.flag = true;
    },
    handleBlur(event) {
      if (!this.isSelect) {
        this.showPrompt = true;
      } else {
        this.showPrompt = false;
      }
    },
    handleFocus(event) {
      if (event.target.value) {
        this.showList = true;
        this.$emit('dropDownChange', event.target.value);
      }
    },
  },
  mounted() {
    this.debounceHandleChange = Tools.Common.debounce(this.handleChange, 500, false);
    if (this.autoFocus) { this.focus(); };
    if (this.itemList.find(item => item === this.inputValue)) {
      this.isSelect = true;
    } else {
      this.isSelect = false;
    }
    document.addEventListener('click', (event) => {
      if ((this.$refs.list && this.$refs.list.contains(event.target)) || (this.$refs.input && this.$refs.input.contains(event.target))) return;
      this.showList = false;
      this.showPrompt = !this.isSelect;
    });
  }
});
</script>

<style lang="scss" scoped>
@import './DropdownSearch';
</style>



// WEBPACK FOOTER //
// src/components/NewComponents/DropdownSearch/DropdownSearch.vue